import styled from 'styled-components'

export const ActionsContainer = styled.div`
  display: flex;
  flex: 1;
  gap: ${props => props.theme.spacing.sp8};
  margin-top: ${props => props.theme.spacing.sp16};
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp32};
`
